"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "1",
  title: "Send your equipment list or asset schedule",
  description: "A machine/asset register, nameplate format, or a file (DXF, DWG, AI, PDF, SVG, {{verify: data file formats e.g. CSV/Excel}})."
}, {
  number: "2",
  title: "Get a quote",
  description: "Materials matched to each area, nameplate/tag/label types, quantity pricing, and lead time."
}, {
  number: "3",
  title: "Approve the proof & scheme",
  description: "Confirm format, numbering, and content once; Evermark applies it plant-wide."
}, {
  number: "4",
  title: "Production & ship",
  description: "Engraved on durable materials and shipped install-ready, with the scheme stored for reorders."
}];
export default function HowToOrder() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="how-to-order" className="bg-accent text-accent-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 md:mb-24 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6 tracking-tight">
            How Do You Order Plant-Wide Labeling?
          </h2>
          <p className="text-lg md:text-xl opacity-80 leading-relaxed">
            Ordering plant-wide identification from Evermark Industrial Solutions takes four steps, built around your asset/equipment list and a proof.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 lg:gap-12 mb-16 md:mb-24">
          {steps.map((step, i) => <div key={i} data-index={i} className={`flex flex-col relative transition-all duration-700 ease-out delay-[${i * 150}ms] ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              {i < steps.length - 1 && <div className="hidden lg:block absolute top-10 left-[calc(100%-2rem)] w-[calc(100%+4rem)] h-px bg-border/30 z-0" />}
              
              <div className="relative z-10 flex flex-col h-full">
                <div className="text-7xl md:text-8xl font-bold text-primary mb-6 font-default leading-none tracking-tighter">
                  {step.number}
                </div>
                <h3 className="font-default text-xl md:text-2xl font-semibold mb-4 leading-tight">
                  {step.title}
                </h3>
                <p className="opacity-80 leading-relaxed text-base md:text-lg">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div ref={ctaRef} className={`text-center transition-all duration-700 ease-out delay-300 ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="text-base md:text-lg px-8 py-6 h-auto">
            <Link to="/ContactPage">Request a Quote</Link>
          </Button>
        </div>
      </div>
    </section>;
}